module.exports = __webpack_public_path__ + "static/img/p1-2-3.ac4d7c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-kv/img/p1-2-3.png
// module id = SZUn
// module chunks = 0